import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/simpi-library.scss';
import App from './App.tsx';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth/msal.ts';
import { AuthGate } from './auth/AuthGate.tsx';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {msalInstance ? (
      <MsalProvider instance={msalInstance}>
        <AuthGate>
          <App />
        </AuthGate>
      </MsalProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);